import { MailAddressOutput } from 'services/device/domain/business/common/Output';
import { LabelRenderer } from 'services/device/presentation/ui/widget/label-renderer/LabelRenderer';
import { MailAddressesOutputValueRenderer } from 'services/device/presentation/ui/widget/output-value-renderer/MailAddressesOutputValueRenderer';

export interface MailAddressesOutputProps {
	output: MailAddressOutput;
}

export const MailAddressesOutputRenderer = (props: MailAddressesOutputProps): JSX.Element => {
	const { output } = props;

	return (
		<li key={output.getName()}>
			<strong>
				<LabelRenderer output={output} />
			</strong>
			<p>
				<MailAddressesOutputValueRenderer output={output} />
			</p>
		</li>
	);

};
